import React from "react";

// Add LoadingDots component
const LoadingDots = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "6px",
      alignItems: "center",
      height: "30px",
      padding: "10px 0",
    }}
  >
    {[0, 1, 2].map((index) => (
      <div
        key={index}
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: "#333",
          animation: `growDot 1.5s infinite ${index * 0.2}s`,
        }}
      />
    ))}
  </div>
);

const HintBox = ({
  hint,
  hintBoxRef,
  hintClosing,
  handleCloseHint,
  isClarificationPlaying,
  hintBoxBottom = "10px",
  audioError,
  isHintLoading,
}) => {
  // Don't render if there's no hint and no loading or clarification is happening
  if (!hint && !isHintLoading && !isClarificationPlaying) return null;

  // Add animation keyframes for the growing dots
  const keyframes = `
    @keyframes growDot {
      0%, 100% { transform: scale(1); opacity: 0.5; }
      50% { transform: scale(1.8); opacity: 1; }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div
        ref={hintBoxRef}
        style={{
          position: "fixed",
          bottom: hintBoxBottom,
          left: "50%",
          transform: `translateX(-50%) ${
            hintClosing ? "translateY(100%)" : "translateY(0)"
          }`,
          background: "#f3e1b2",
          color: "#000",
          padding: "20px",
          borderRadius: "12px",
          width: "95%",
          maxWidth: "800px",
          textAlign: "center",
          animation: "slideUp 0.5s ease-out",
          zIndex: 100,
          fontFamily: "'Inter', sans-serif",
          fontWeight: 700,
          fontSize: "24px",
          letterSpacing: "0.5px",
          transition: "transform 0.5s ease-out",
          overflow: "visible",
        }}
      >
        <div style={{ position: "relative" }}>
          <button
            onClick={handleCloseHint}
            style={{
              position: "absolute",
              top: "-10px",
              left: "-10px",
              margin: "0",
              background: "transparent",
              border: "none",
              fontWeight: "bold",
              fontSize: "26px",
              cursor: "pointer",
            }}
            aria-label="Close hint"
          >
            X
          </button>

          {/* Removed clarification button */}

          {/* Show loading dots only when hint is loading (not when playing) */}
          {isHintLoading ? (
            <LoadingDots />
          ) : (
            <p style={{ marginLeft: "35px", marginRight: "35px" }}>{hint}</p>
          )}
        </div>
        {audioError && (
          <div style={{ marginTop: "10px", color: "red" }}>{audioError}</div>
        )}
      </div>
    </>
  );
};

export default HintBox;
